export default __webpack_public_path__ + "static/media/background.be237f4c.jpeg";